import { render, staticRenderFns } from "./productEn.vue?vue&type=template&id=2209c5e5&scoped=true&"
import script from "./productEn.vue?vue&type=script&lang=js&"
export * from "./productEn.vue?vue&type=script&lang=js&"
import style0 from "./productEn.vue?vue&type=style&index=0&id=2209c5e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2209c5e5",
  null
  
)

export default component.exports